import { ref } from '@vue/composition-api'
import moment from 'moment'
import 'moment-timezone'

const timeZone = 'Asia/Riyadh';

const time = {
  hour: 18,
  minute: 0,
  second: 0,
}

const yesterday = moment().tz(timeZone).subtract(1, 'day').set(time).format('YYYY-MM-DD HH:mm:ss');
const today = moment().tz(timeZone).set(time).format('YYYY-MM-DD HH:mm:ss');
const rangeDate = ref(`${yesterday} to ${today}`)
const from = ref(yesterday)
const to = ref(today)

const conf = {
  mode:'range',
  enableTime: true,
  enableSeconds:true,
  time_24hr: true,
  defaultHour: 0,
  dateFormat: 'Y-m-d H:i:S',
  defaultDate: [
    yesterday,
    today,
  ],
  onClose: function (data, dateStr) {
    const date = dateStr.split(' to ')
    from.value = date[0]
    to.value = date[1]
  },
  onChange: function(rawdate, altdate, FPOBJ) {
    // FPOBJ.close(); // Close datepicker on date select
    // FPOBJ._input.blur(); // Blur input field on date select
  }
}


export {
  rangeDate,
  conf,
  from,
  to
}